import Helper from './Helper/index';
import Layout from './Layout/index';
import Template from './Template/index';
import Ui from './Ui/index';
import BlockLoader from './BlockLoader';
import Connect from './Connect';
import DataApplier from './DataApplier';
import MessageFader from './MessageFader';
import Popup from './Popup';
import Polling from './Polling';
import { on, off, trigger } from './trigger';
import { pages, page } from './page';
import {pNotify} from './pnotifier';
import vue3initializer from "../vue3/initialization/initializer";

const esearcher = {
    Helper,
    Layout,
    Template,
    Ui,
    BlockLoader,
    Connect,
    DataApplier,
    MessageFader,
    Polling,
    Popup,
    on,
    off,
    trigger,
    page,
    pages,
    pNotify,
    vue3initializer
};

window.Esearcher = esearcher;

export default esearcher;
